import { isDev, isLocalhost, isPackagedDevApp } from '../client-utils';

// Beta/prod opt-in (debug page → runtime-opt-in.ts): flips the runtime gate for
// this page load. Dev builds are enabled via the compile-time `__POP_DEVTOOLS__`
// path instead, so turning this off never disables a dev build.
let runtimeOptIn = false;
const enabledChangeListeners = new Set<() => void>();

export const setPopDevToolsRuntimeOptIn = (enabled: boolean) => {
  if (runtimeOptIn === enabled) return;
  runtimeOptIn = enabled;
  enabledChangeListeners.forEach((listener) => {
    listener();
  });
};

export const isPopDevToolsRuntimeOptIn = () => runtimeOptIn;

export const subscribeToPopDevToolsEnabledChanges = (listener: () => void) => {
  enabledChangeListeners.add(listener);
  return () => {
    enabledChangeListeners.delete(listener);
  };
};

export const isPopDevToolsEnabled = () =>
  runtimeOptIn || (__POP_DEVTOOLS__ && (isDev || isLocalhost || isPackagedDevApp));

export const getPopDevToolsAvailability = () => ({
  enabled: isPopDevToolsEnabled(),
  runtimeOptIn,
  isDev,
  isLocalhost,
  isPackagedDevApp,
  host: window.location.host,
  href: window.location.href,
  userAgent: navigator.userAgent,
});
